import { appLoginUrl } from '@/config/appLinks';

export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
  opensModal?: boolean;
  live?: boolean;
}

export interface FooterColumn {
  head: string;
  links: readonly FooterLink[];
}

export interface FooterCopy {
  columns: readonly FooterColumn[];
  copyright: string;
}

export const FOOTER_EN: FooterCopy = {
  columns: [
    {
      head: 'Product',
      links: [
        { label: 'Pricing',  href: '/pricing' },
        { label: 'Trust',    href: '/trust' },
        { label: 'Status',   href: 'https://status.prinotes.com/', external: true, live: true },
        /* Built from appLinks, not hardcoded: a literal here would silently keep
         * pointing at the old URL if the app's login route ever moves, and the
         * test asserted the same literal so nothing would have caught it. */
        { label: 'Log in',   href: appLoginUrl('en'), external: true, live: true },
      ],
    },
    {
      head: 'Company',
      links: [
        { label: 'Support',        href: 'mailto:support@prinotes.com', live: true },
        { label: 'About Prinotes', href: '/about', live: true },
      ],
    },
    {
      head: 'Trust Center',
      links: [
        { label: 'Privacy Policy',    href: '/privacy', live: true },
        { label: 'Terms of Service',  href: '/terms', live: true },
        { label: 'Sub-processors',    href: '/subprocessors', live: true },
        { label: 'Manage Cookies',    href: '#manage-cookies', opensModal: true },
      ],
    },
    {
      head: 'Connect',
      links: [
        { label: 'LinkedIn',  href: 'https://www.linkedin.com/company/prinotes', external: true },
        { label: 'Instagram', href: 'https://www.instagram.com/prinotes',         external: true },
        { label: 'X',         href: 'https://x.com/prinotes',                     external: true },
      ],
    },
  ],
  copyright: '© 2026 Prinotes · All rights reserved · Product of PRIYORA Company LLC',
};
